import { lazy } from 'react';

export { Accessorials } from './accessorials';

export const LazyAccessorials = lazy(() => import('./accessorials').then((mod) => ({ default: mod.Accessorials })));
